var _ellipse, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 156,
    viewBox: "0 0 228 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.981,
    cy: 151.434,
    rx: 88.8783,
    ry: 3.7664,
    fill: "url(#paint0_radial)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.3286,
    cy: 52.4575,
    r: 5,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.2236,
    cy: 4.5625,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.002,
    cy: 126.562,
    r: 2.89502,
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.04053,
    y1: 86.1274,
    x2: 4.04053,
    y2: 92.1274,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.10303,
    y1: 89.3774,
    x2: 1.10303,
    y2: 89.3774,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 209.291,
    y1: 27.8774,
    x2: 209.291,
    y2: 33.8774,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 212.353,
    y1: 31.1274,
    x2: 206.353,
    y2: 31.1274,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 150.056,
    y1: 11.4902,
    x2: 150.056,
    y2: 17.4902,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 153.119,
    y1: 14.7402,
    x2: 147.119,
    y2: 14.7402,
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5106 46.4575H43.9406C43.738 46.4575 43.5737 47.3163 43.5737 48.3757V132.749C43.5737 133.809 43.738 134.667 43.9406 134.667H69.5106C69.7132 134.667 69.8774 133.809 69.8774 132.749V48.3757C69.8774 47.3163 69.7132 46.4575 69.5106 46.4575Z",
    fill: "#DDE4EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.011 13.7402H79.4406C79.238 13.7402 79.0737 14.9176 79.0737 16.3698V132.038C79.0737 133.49 79.238 134.667 79.4406 134.667H105.011C105.213 134.667 105.377 133.49 105.377 132.038V16.3698C105.377 14.9176 105.213 13.7402 105.011 13.7402Z",
    fill: "#DDE4EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.51 30.1274H114.94C114.738 30.1274 114.573 31.1452 114.573 32.4007V132.394C114.573 133.65 114.738 134.667 114.94 134.667H140.51C140.713 134.667 140.877 133.65 140.877 132.394V32.4007C140.877 31.1452 140.713 30.1274 140.51 30.1274Z",
    fill: "#DDE4EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.993 76.4409H149.423C149.22 76.4409 149.056 77.0078 149.056 77.7071V133.401C149.056 134.101 149.22 134.667 149.423 134.667H174.993C175.196 134.667 175.36 134.101 175.36 133.401V77.7071C175.36 77.0078 175.196 76.4409 174.993 76.4409Z",
    fill: "#DDE4EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.493 110.941H184.923C184.72 110.941 184.556 111.172 184.556 111.457V134.152C184.556 134.436 184.72 134.667 184.923 134.667H210.493C210.695 134.667 210.86 134.436 210.86 134.152V111.457C210.86 111.172 210.695 110.941 210.493 110.941Z",
    fill: "#DDE4EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.4768,
    y: 39.5977,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1909 39.5977C48.8741 39.5977 46.6093 40.2847 44.6829 41.5718C42.7565 42.859 41.2551 44.6885 40.3685 46.829C39.4819 48.9694 39.2499 51.3248 39.7019 53.5971C40.1539 55.8694 41.2695 57.9566 42.9078 59.5949C44.546 61.2331 46.6333 62.3488 48.9056 62.8008C51.1779 63.2528 53.5332 63.0208 55.6737 62.1342C57.8142 61.2476 59.6437 59.7462 60.9308 57.8198C62.218 55.8934 62.905 53.6286 62.905 51.3118C62.8959 48.2078 61.6589 45.2335 59.464 43.0387C57.2692 40.8438 54.2949 39.6067 51.1909 39.5977Z",
    fill: "#56D187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6195 45.3115H50.7623C50.4468 45.3115 50.1909 45.6697 50.1909 46.1115V56.5115C50.1909 56.9534 50.4468 57.3115 50.7623 57.3115H51.6195C51.9351 57.3115 52.1909 56.9534 52.1909 56.5115V46.1115C52.1909 45.6697 51.9351 45.3115 51.6195 45.3115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1909 51.7401V50.883C57.1909 50.5674 56.8443 50.3115 56.4167 50.3115H45.9651C45.5375 50.3115 45.1909 50.5674 45.1909 50.883V51.7401C45.1909 52.0557 45.5375 52.3115 45.9651 52.3115H56.4167C56.8443 52.3115 57.1909 52.0557 57.1909 51.7401Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.981 151.434) rotate(90) scale(3.7664 88.8783)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.4768,
    y: 39.5977,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.2721446fff0f9aae44c41ea49b963981.svg";
export { ForwardRef as ReactComponent };